import { useMutation } from '@apollo/client/react';

import type { SpeechSynthesisPort } from '@/shared-responder-v2-core';
import { useSpeechSynthesisPortFromMutation } from '@/shared-responder-v2-media';
import { GENERATE_MODERATOR_SPEECH_V2 } from '@/survey-graphql';

// test-exception: Apollo binding only — the cache, abort and object-URL logic is useSpeechSynthesisPortFromMutation, covered by shared-responder-v2-media-speech.hooks.spec.tsx and shared-responder-v2-media-speech.helpers.spec.ts.
export function useSurveySpeechSynthesisPort(
  projectId: string | undefined
): SpeechSynthesisPort {
  const [generateModeratorSpeech] = useMutation(GENERATE_MODERATOR_SPEECH_V2);

  return useSpeechSynthesisPortFromMutation(async ({ signal, text }) => {
    if (!projectId) {
      console.error(
        '[useSurveySpeechSynthesisPort] missing projectId — cannot synthesize moderator speech'
      );
      return null;
    }

    const { data } = await generateModeratorSpeech({
      variables: { input: { projectId, text } },
      context: { fetchOptions: { signal } },
    });

    return data?.generateModeratorSpeechV2.audioData ?? null;
  });
}
